import React, { useContext, useCallback, useMemo } from 'react';
import { Portal } from 'react-portal';
import { analyticService } from 'global/services';

import { getDishesFromBasketSections } from 'app/utils/dish';
import { DishButton } from '../../DishButtons';
import { ConfigContext } from '../../ConfigProvider';
import { PromoCheckoutPatchedDishesContext } from '../../PromoCheckoutMenuDishesAdapter';
import { BasketContext } from '../../BasketProvider';

export const DishLayoutIsolatedButton = ({ nodeId }) => {
    const buttonCardPortalNode = document.querySelector(`#${nodeId}`);
    const id = buttonCardPortalNode?.dataset.dish_id;

    const { dishesArray } = useContext(PromoCheckoutPatchedDishesContext);
    const { pageId } = useContext(ConfigContext);
    const { basket } = useContext(BasketContext);

    const basketDishes = useMemo(
        () => getDishesFromBasketSections(basket.sections),
        [basket.sections],
    );

    const portion = useMemo(
        () => basketDishes.find((d) => d.id === id)?.portion || 0,
        [basketDishes, id],
    );

    const targetDish = dishesArray.find((d) => d.id === id);
    if (!targetDish || targetDish?.isSoldOut) return null;

    const {
        title,
        category,
        giftWrapId,
        originalPriceWithStep,
        discountPriceWithStep,
        price,
        dishCountStep,
        maxPortion,
    } = targetDish;

    const joinedTitle = title.join(' ');

    const trackAddToBasket = ({ portions }) => {
        analyticService.push({
            eventName: 'add_to_cart',
            dishes: [{
                id,
                title: joinedTitle,
                caption: '',
                price,
                portion: portions,
                categoryId: category,
            }],
            source: pageId,
            subscriptionType: 'singlePay',
            typeOfSet: 'refular',
        });
    };
    return (
        <Portal node={buttonCardPortalNode}>
            <DishButton
                id={id}
                giftWrapId={giftWrapId}
                originalPriceWithStep={originalPriceWithStep}
                discountPriceWithStep={discountPriceWithStep}
                price={price}
                dishCountStep={dishCountStep}
                portion={portion}
                maxPortion={maxPortion}
                isInfoBlock
                buttonsDisabled={false}
                onClickAddToBasket={trackAddToBasket}
            />
        </Portal>
    );
};
